import { Button } from "~/components/ui/button";
import { HeartFilledIcon } from "~/icons/HeartFilledIcon";
import { HeartIcon } from "~/icons/HeartIcon";
import { LetterIcon } from "~/icons/LetterIcon";
import { ShareIcon } from "~/icons/ShareIcon";
import { cn } from "~/lib/utils";

interface LocationActionsProps {
  onRequest?: () => void;
  onBookmark?: () => void;
  onShare?: () => void;
  isBookmarked?: boolean;
  bookmarkingBusy?: boolean;
  /** Icon-only compact row for subnavigation (e.g. when sidebar actions are scrolled out) */
  variant?: "default" | "compact";
  className?: string;
}

export function LocationActions({
  onRequest,
  onBookmark,
  onShare,
  isBookmarked,
  bookmarkingBusy,
  variant = "default",
  className,
}: LocationActionsProps) {
  if (variant === "compact") {
    return (
      <div className={cn("flex items-center gap-4 shrink-0", className)}>
        <Button
          onClick={onRequest}
          size="default"
          className="rounded-md"
          title="Anfragen"
          aria-label="Jetzt kostenlos anfragen"
        >
          <LetterIcon className="size-5" />
          Anfragen
        </Button>
        <Button
          onClick={onBookmark}
          variant="black"
          size="default"
          className="rounded-md shrink-0"
          loading={bookmarkingBusy}
          title="Merken"
          aria-label={isBookmarked ? "Von Merkliste entfernen" : "Merken"}
        >
          {isBookmarked ? (
            <HeartFilledIcon className="text-primary size-5" />
          ) : (
            <HeartIcon className="text-primary size-5" />
          )}
        </Button>
        <Button
          onClick={onShare}
          variant="outline"
          size="default"
          className="rounded-md border-2 shrink-0"
          title="Teilen"
          aria-label="Teilen"
        >
          <ShareIcon className="size-5" />
        </Button>
      </div>
    );
  }

  return (
    <div>
      <div className="bg-lemon-lightest p-6 text-center rounded-md">
        <div className="flex flex-col gap-3">
          <Button onClick={onRequest} className="justify-start">
            <LetterIcon />
            Jetzt kostenlos anfragen
          </Button>

          <Button
            onClick={onBookmark}
            variant={"black"}
            className="justify-start"
            loading={bookmarkingBusy}
          >
            {isBookmarked ? (
              <HeartFilledIcon className="text-primary" />
            ) : (
              <HeartIcon className="text-primary" />
            )}
            Merken
          </Button>

          <Button
            onClick={onShare}
            variant={"outline"}
            className="border-2 justify-start"
          >
            <ShareIcon />
            Teilen
          </Button>
        </div>
      </div>
    </div>
  );
}
